export const environment = {
  production: false,
  MAIN_API_URL: 'https://api.dev.inlite.coffeeit.nl',
  AUTH_ASSISTANT_API_URL: 'https://api.dev.inlite.coffeeit.nl/smarthome/auth',
};
